// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"bf72e791","77":"6275f190","296":"48b70c1d","376":"ae42a43c","599":"aed52100","675":"7fc55a5a","808":"9652d2b2","833":"24319865"}[chunkId] + ".chunk.js";
};